/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

const columnsStokAksesuar = [
  { Header: "Aksesuar Adı", accessor: "name" },
  { Header: "Miktar", accessor: "quantity" },
  { Header: "İşlemler", accessor: "actions" },
];

export default columnsStokAksesuar;
